import React, { useContext } from 'react';

import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography,
} from '@material-ui/core';
import { PatientTabsContext } from '../../../lib/contexts';
import useMetric from '../../../lib/hooks/useMetric';
import { ProgressBar } from '../../../components/ProgressBar';
import { PatientCheckInHistoryRow } from './index';

const useStyles = makeStyles(theme => ({
  patientChartCard: theme.globalClasses.patientChartCard,
  container:{
    maxHeight: 600,
    overflowY: 'scroll'
  },
  topBar:{
    marginBottom:10
  },
  tableHead: theme.globalClasses.adminTableHead,
  tableRow: theme.globalClasses.adminTableRow
}));

const PatientNotesBox = ({ summary, setSetSubtab }) => {
  const classes = useStyles();
  const {
    state: { currentTab },
  } = useContext(PatientTabsContext);
  const {isLoading, data } = useMetric('checkin_history', currentTab.id);
  return (
    <Grid item xs={summary ? 9 : 12} >
      <Paper className={classes.patientChartCard}>
        <Grid item container xs={12} className={classes.topBar}>
          <Grid item xs={11}>
            <Typography variant={'h2'}>Check-In History</Typography>
          </Grid>
          {summary && <Grid item xs={1}>
            <Typography variant={'h3'} onClick={() => setSetSubtab('1')}>View All</Typography>
          </Grid>}
        </Grid>
        {isLoading ?
          <ProgressBar /> :
          <Box className={classes.container}>
            <Table>
              <TableHead className={classes.tableHead}>
                <TableRow className={classes.tableRow}>
                  <TableCell align="left">Date</TableCell>
                  <TableCell align="left">Challenge</TableCell>
                  <TableCell align="left">Day #</TableCell>
                  <TableCell align="left">Feeling</TableCell>
                  <TableCell align="left">Meal Type</TableCell>
                  <TableCell align="left">Checked-In</TableCell>
                  <TableCell align="left">Paused</TableCell>
                  <TableCell align="left">Succeeded</TableCell>
                  <TableCell align="left">User Notes</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
            {data && data.metric && data.metric.value
              .slice(0, summary ? 3 : data.metric.value.length).map((item, index)=>{
              return (
                <PatientCheckInHistoryRow key={index} row={item} summary={summary}  />
              )
            })}
              </TableBody>
            </Table>
          </Box>
        }
      </Paper>
    </Grid>
  );
};

export default PatientNotesBox;
